export default __webpack_public_path__ + "static/media/logo-TRED-UNION.17d9e1df.png";